/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9302a31b (Tue Nov  3 17:38:29 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface DeclinePotentialInviteRequestBody
 */
export interface DeclinePotentialInviteRequestBody {
  /**
   * The unique identifier for the decline reason.
   * @type number
   * @memberof DeclinePotentialInviteRequestBody
   */
  potentialInviteDeclineReasonKey: number
  /**
   * The director the decision is made for, sent by a CSL acting for an LCD. Defaults to the acting actor. Must be the acting actor or in their downline.
   * @type number
   * @memberof DeclinePotentialInviteRequestBody
   */
  actorKey?: number
}

export function DeclinePotentialInviteRequestBodyFromJSON(
  json: any
): DeclinePotentialInviteRequestBody {
  return DeclinePotentialInviteRequestBodyFromJSONTyped(json, false)
}

export function DeclinePotentialInviteRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeclinePotentialInviteRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    potentialInviteDeclineReasonKey: json['potentialInviteDeclineReasonKey'],
    actorKey: !exists(json, 'actorKey') ? undefined : json['actorKey'],
  }
}

export function DeclinePotentialInviteRequestBodyToJSON(
  value?: DeclinePotentialInviteRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    potentialInviteDeclineReasonKey: value.potentialInviteDeclineReasonKey,
    actorKey: value.actorKey,
  }
}
